import { useCallback, useEffect, useState } from 'react';

const SKELETON_DELAY_MS = 200;

export default function usePagedListUi({
  currentPage,
  setCurrentPage,
  loading = false,
  scrollTargetRef,
} = {}) {
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowSkeleton(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setShowSkeleton(true), SKELETON_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [loading]);

  const goToPage = useCallback(
    (nextPage) => {
      const page = Math.max(1, Number(nextPage) || 1);
      setCurrentPage(page);
      const target = scrollTargetRef?.current;
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    [scrollTargetRef, setCurrentPage]
  );

  return { showSkeleton, goToPage };
}
